import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { ErrorDetails } from '../../authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';

export class GetEmailTemplatesCommand extends IRequestCommand<
  IGetEmailTemplatesResponse,
  ErrorDetails,
  IGetEmailTemplatesParameters> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/{carrierId}/emailsTemplates';

  public override setParameters(parameters: IGetEmailTemplatesParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierId}',
      parameters.idCarrier ? parameters.idCarrier.toString() : ''
    );
    if (parameters.language) {
      this._commandUrl = this._commandUrl + '?language=' + parameters.language;
    }
    this._commandBody = parameters;
  }
}

export interface IGetEmailTemplatesParameters {
  idCarrier: number;
  language?: string;
}

export interface IGetEmailTemplatesResponse extends ICommandResponse {
}
